import { render, staticRenderFns } from "./MatchingHome.vue?vue&type=template&id=7291dc2a&scoped=true&"
import script from "./MatchingHome.vue?vue&type=script&lang=js&"
export * from "./MatchingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7291dc2a",
  null
  
)

export default component.exports